import React, { Component, Fragment } from 'react';
import Toaster from '../../components/ReusableComponents/Toaster/Toaster';
import { toasterSubscriber, toolTipService } from '../../services/subscriberService';
import { withRouter } from 'react-router-dom';
import Modals from '../../components/UI/Modals/Modals';
import Spinner from '../../components/UI/Loader/Loader';
import Download from '../../components/ReusableComponents/Download/Download';

const LayoutHOC = (WrappedComponent) => {
    return class extends Component {
        state = {
            toasterData: [],
            toolTip: null
        }
    
        componentDidMount() {
            this.subscription1 = toolTipService.getToolTip().subscribe(async(data) => {
                this.setState({toolTip: data});
            });
            this.subscription = toasterSubscriber.getToasterData().subscribe(data => {
                if (data.data.type && data.data.type === 'copy') {
                    const temp = this.state.toasterData.filter(el => el.type && el.type === 'copy' && el.id && el.id === data.data.id);
                    if (temp.length) {
                        return;
                    }
                }
                this.setState(prevState => ({
                    toasterData: [...prevState.toasterData, data.data]
                }));
            });
        }
    
        componentDidUpdate = (nextProps, nextState) => {
            if (this.state.toasterData.length && this.state.toasterData !== nextState.toasterData) {
                setTimeout(() => {
                    this.setState(prevState => ({
                        toasterData: prevState.toasterData.splice(1, prevState.toasterData.length - 1)
                    }));
                }, 3000);
            }
        }
    
        componentWillUnmount() {
            this.subscription.unsubscribe();
            this.subscription1.unsubscribe();
        }
    
        render() {
            return <WrappedComponent {...this.state} {...this.props} />;
        }
    }
};

const Layout = ({toasterData, toolTip, children}) => {
    // const toast = useMemo(() => toasterData.map((el, index) => <Toaster key={index} data={el} />),[toasterData.length]);
    let toast = null;
    if(toasterData.length) {
        toast = toasterData.map((el, index) => <Toaster key={index} data={el} />)
    }
    return (
        <Fragment>
            {toolTip}
            <Modals />
            <Spinner />
            <Download />
            <ExtraDiv clas="toaster_div" data={toast} />
            <div style={{ position: 'relative' }}>
                {children}
            </div>
        </Fragment>
    )
}

const LayoutComponent = LayoutHOC(Layout,{});
export default withRouter(LayoutComponent);

const ExtraDiv = ({ clas, data }) => (
    <div className={clas}>
        {data}
    </div>
);
